<template>
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>
                <router-link class="btn btn-sm" :to="{ name: 'ActivationPinList' }"
                  ><i class="fas fa-chevron-left"></i>
                </router-link>
                Activation Key
              </h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Activation Key</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="container-fluid">
          <div class="card" id="SNMP">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header py-3">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
              </div>
              <div class="card-body pb-1">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group required">
                      <label class="control-label">Country</label>
                      <multiselect
                        v-model="value.country"
                        :options="pre.countries"
                        placeholder="Select Country"
                        :searchable="true"
                        :multiple="false"
                        id="country"
                        v-bind:class="{ 'has-error': errors.has('country') }"
                        v-validate="'required'"
                        name="country"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('country')">
                        {{ errors.first("country") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Organization</label>
                      <multiselect
                        v-model="value.org_id"
                        :options="Object.keys(pre.organizations)"
                        :custom-label="(opt) => pre.organizations[opt]"
                        placeholder="Select Organization"
                        :searchable="true"
                        :multiple="false"
                        id="org_id"
                        v-bind:class="{ 'has-error': errors.has('org_id') }"
                        v-validate="'required'"
                        name="organization"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('organization')">
                        {{ errors.first("organization") }}
                      </div>
                    </div>

                    <h4 class="card-common-title p-0 mb-2 pb-2 border-bottom">
                      Choose DC
                    </h4>

                    <div class="form-group required">
                      <label class="control-label">Data Center</label>
                      <multiselect
                        v-model="value.datacenter_id"
                        :options="Object.keys(pre.dataCenters)"
                        :custom-label="(opt) => pre.dataCenters[opt]"
                        placeholder="Select Data Center"
                        :searchable="true"
                        :multiple="false"
                        id="datacenter_id"
                        v-bind:class="{ 'has-error': errors.has('datacenter_id') }"
                        v-validate="'required'"
                        name="data center"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('data center')">
                        {{ errors.first("data center") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">MAC</label>
                      <input
                        type="text"
                        id="mac"
                        name="mac"
                        v-model="value.mac"
                        v-validate.lazy="{required: true, regex: /^(?:[0-9A-Fa-f]{2}[:-]){5}(?:[0-9A-Fa-f]{2})$/}"
                        class="form-control mac"
                        placeholder="mac"
                      />
                      <div class="help text-danger" v-show="errors.has('mac')">
                        {{ errors.first("mac") }}
                      </div>
                    </div>

                    <div v-if="is_edit" class="form-group required">
                      <label class="control-label">Pin</label>
                      <input
                        type="text"
                        id="actv_key"
                        name="actv_key"
                        v-model="value.actv_key"
                        v-validate.lazy="{required: true, min: 8, max: 35, numeric: true}"
                        class="form-control actv_key"
                        placeholder="Pin"
                      />
                      <div class="help text-danger" v-show="errors.has('actv_key')">
                        {{ errors.first("actv_key") }}
                      </div>
                    </div>

                    <div v-if="is_edit" class="form-group required">
                      <label class="control-label">Status</label>
                      <multiselect
                        v-model="value.status"
                        :options="pre.status"
                        placeholder="Select Status"
                        :searchable="true"
                        :multiple="false"
                        id="status"
                        v-bind:class="{ 'has-error': errors.has('status') }"
                        v-validate="'required'"
                        name="status"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('status')">
                        {{ errors.first("status") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Serial</label>
                      <input
                        type="text"
                        id="serial"
                        name="serial"
                        v-model="value.serial"
                        class="form-control serial"
                        placeholder="Serial"
                      />
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Type</label>
                      <multiselect
                        v-model="value.utype"
                        :options="pre.types"
                        placeholder="Select Type"
                        :searchable="true"
                        :multiple="false"
                        id="utype"
                        v-bind:class="{ 'has-error': errors.has('utype') }"
                        v-validate="'required'"
                        name="type"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('type')">
                        {{ errors.first("type") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Model No</label>
                      <multiselect
                        v-model="value.device_type"
                        :options="pre.deviceTypes"
                        placeholder="Select Model No"
                        :searchable="true"
                        :multiple="false"
                        id="device_type"
                        v-bind:class="{ 'has-error': errors.has('device_type') }"
                        v-validate="'required'"
                        name="device_type"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('device_type')">
                        {{ errors.first("device_type") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">User License</label>
                      <input
                        type="text"
                        id="license_user"
                        name="license_user"
                        v-model="value.license_user"
                        v-validate="{required: true, numeric: true}"
                        class="form-control license_user"
                        placeholder="User License"
                      />
                      <div class="help text-danger" v-show="errors.has('license_user')">
                        {{ errors.first("license_user") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Version</label>
                      <input
                        type="text"
                        id="version"
                        name="version"
                        v-model="value.version"
                        v-validate="'required'"
                        class="form-control version"
                        placeholder="Version"
                      />
                      <div class="help text-danger" v-show="errors.has('version')">
                        {{ errors.first("version") }}
                      </div>
                    </div>

                    <h4 class="card-common-title p-0 mb-2 pb-2 border-bottom">
                      CGW
                    </h4>

                    <div class="form-group required">
                      <label class="control-label">Rate</label>
                      <multiselect
                        v-model="value.rate_id"
                        :options="Object.keys(pre.rates)"
                        :custom-label="(opt) => pre.rates[opt]"
                        placeholder="Select Rate"
                        :searchable="true"
                        :multiple="false"
                        id="rate_id"
                        v-bind:class="{ 'has-error': errors.has('rate_id') }"
                        v-validate="'required'"
                        name="rate"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('rate')">
                        {{ errors.first("rate") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Subscription Root</label>
                      <multiselect
                        v-model="value.sroot"
                        :options="Object.keys(pre.subscriptionRoots)"
                        :custom-label="(opt) => pre.subscriptionRoots[opt]"
                        placeholder="Select Subscription Root"
                        :searchable="true"
                        :multiple="false"
                        id="sroot"
                        v-bind:class="{ 'has-error': errors.has('sroot') }"
                        v-validate="'required'"
                        name="sroot"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('sroot')">
                        {{ errors.first("sroot") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Subscription Group</label>
                      <multiselect
                        v-model="value.sgrp"
                        :options="Object.keys(pre.subscriptionGroups)"
                        :custom-label="(opt) => pre.subscriptionGroups[opt]"
                        placeholder="Select Subscription Group"
                        :searchable="true"
                        :multiple="false"
                        id="sgrp"
                        v-bind:class="{ 'has-error': errors.has('sgrp') }"
                        v-validate="'required'"
                        name="sgrp"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('sgrp')">
                        {{ errors.first("sgrp") }}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card-footer pt-0 pb-4">
                <button type="submit" v-if="!is_edit" class="btn">Submit</button>
                <button type="submit" v-if="is_edit" class="btn">Update</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "ActivationPinForm",
  metaInfo: {
    title: "Activation Key | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      countries: [],
      organizations: {},
      dataCenters: {},
      status: ['ACTIVE', 'INACTIVE', 'USED'],
      types: ['SOHO', 'HOME'],
      deviceTypes: ['MT7621_NO_WIFI', 'x86_NO_WIFI', 'RTLSDK3411D_WIFI', 'MT7620_NO_WIFI', 'Audra-MX-250', 'Audra_Safe_30'],
      rates: { audra_free: 'FREE', audra_soho_sub: 'AUDRA SOHO', audra_home_sub: 'Audra Home' },
      subscriptionRoots: { safenet: 'SAFENET' },
      subscriptionGroups: {
        safenetap: 'SAFENETAP',
        safenet_1day: '1 Day Demo',
        safenet_2day: '2 Day Demo',
        safenet_31day: '31 Day',
        safenet_1month_demo: '1 Month Demo',
        safenet_1month_grace: '1 Month Grace',
        safenet_1year: 'SAFENET 1 YEAR',
        safenet_2year: 'SAFENET 2 YEAR',
        safenet_3year: 'SAFENET 3 YEAR',
        safenet_home: 'SAFENET HOME',
        safenet_soho: 'SAFENET SOHO',
        safenet_lifetime: 'SAFENET LIFETIME'
      }
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/activation_pins";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/activation_pins/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "ActivationPinList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/activation_pins/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      }

      await this.getOrganizations()
        .then((response) => {
          this.pre.organizations = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getCountries()
        .then((response) => {
          this.pre.countries = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getDataCenters()
        .then((response) => {
          this.pre.dataCenters = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },

    getOrganizations: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-activation-pin-organizations", {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    getCountries: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-activation-pin-countries")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getDataCenters: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-data-centers")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
      this.$emit("update:layout", MasterLayout);
    }, */
};
</script>
